export interface SubjectAndContentProps {
    index: number;
}

export type ContentBoxProps = {
    icon: JSX.Element;
    title: string;
    description: string;
    onBoxClick(): void;
    id: string;
};

export type EmailDropdownType = {
    fromEmail: string;
    setFromEmail(email: string): void;
    id: string;
    isFromEmail?: boolean;
    label?: string;
    hasError?: boolean;
    isTipVisible?: boolean;
    errorMessage?: string;
};

export type FromEmailTipType = {
    isTipVisible: boolean;
    openExitModal(): void;
};

export enum ScreenType {
    CC = 'CC',
    Template = 'TemplateScr',
}

export enum FromEmailEnum {
    Domains = 'Domains',
    Emails = 'Emails',
}

export type EmailOptionsType = {
    name: string;
    group?: FromEmailEnum;
};

export type CampaignSubjectType = {
    id: string;
};

export type TemplatePreviewButtonType = {
    buttonIcon: JSX.Element;
    buttonLabel?: string;
    handleOnClick(): void;
    id?: string;
};

export type ContentBoxesConfigType = {
    icon: JSX.Element;
    title: string;
    description?: string;
    onBoxClick(): void;
    id: string;
};

export type CampaignFromProps = {
    showReplyTo: boolean;
    setShowReplyTo(showReplyTo: boolean): void;
};

export type ReplyToCheckboxProps = CampaignFromProps;

export type SaveInMyTemplatesModalProps = {
    templateName: string;
    setTemplateName(templateName: string): void;
    fromName: string;
    setFromName(name: string): void;
    fromEmail: string;
    setFromEmail(email: string): void;
    subject: string;
    setSubject(subject: string): void;
    isEmailInvalid(email?: string): boolean;
};
